/**
 * Countdown
 */
function countdownInit() {
    const second = 1000,
          minute = second * 60,
          hour   = minute * 60,
          day    = hour * 24;
  
    const date = document.querySelector('[data-date]').dataset.date;

    // const dateElement = document.querySelector('.homepage-countdown');
    // const date = dateElement ? dateElement.getAttribute('data-date') : null;
  
    let countDown = new Date(date).getTime(),
      x = setInterval(function () {
  
        let now = new Date().getTime(),
            distance = countDown - now;
  
        if (document.querySelector('[data-days]') != null) {
          let days = Math.floor(distance / (day));
          if (days < 10) {
            days = "0" + days;
          }
          let daysFirstDigit = days.toString().charAt(0);
          let daysSecondDigit = days.toString().charAt(1);
          let daysHTML = `
            <span>${daysFirstDigit}</span>
            <span>${daysSecondDigit}</span>
          `;
          document.querySelector('[data-days]').innerHTML = daysHTML;
        }
  
        if (document.querySelector('[data-hours]') != null) {
          let hours = Math.floor((distance % (day)) / (hour));
          if (hours < 10) {
            hours = "0" + hours;
          }
          let hoursFirstDigit = hours.toString().charAt(0);
          let hoursSecondDigit = hours.toString().charAt(1);
          let hoursHTML = `
            <span>${hoursFirstDigit}</span>
            <span>${hoursSecondDigit}</span>
          `;
          document.querySelector('[data-hours]').innerHTML = hoursHTML;
        }
  
        if (document.querySelector('[data-minutes]') != null) {
          let minutes = Math.floor((distance % (hour)) / (minute));
          if (minutes < 10) {
            minutes = "0" + minutes;
          }
          let minutesFirstDigit = minutes.toString().charAt(0);
          let minutesSecondDigit = minutes.toString().charAt(1);
          let minutesHTML = `
            <span>${minutesFirstDigit}</span>
            <span>${minutesSecondDigit}</span>
          `;
          document.querySelector('[data-minutes]').innerHTML = minutesHTML;
        }
  
        if (document.querySelector('[data-seconds]') != null) {
          let seconds = Math.floor((distance % (minute)) / second);
          if (seconds < 10) {
            seconds = "0" + seconds;
          }
          let secondsFirstDigit = seconds.toString().charAt(0);
          let secondsSecondDigit = seconds.toString().charAt(1);
          let secondsHTML = `
            <span>${secondsFirstDigit}</span>
            <span>${secondsSecondDigit}</span>
          `;
          document.querySelector('[data-seconds]').innerHTML = secondsHTML;
        }
  
        // if (distance < 0) {
        //   clearInterval(x);
        // }
      }, second)
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    countdownInit();
  });